import { Select, MenuItem, TextField } from "@mui/material";
import modalStyles from "./MultiAccountOrderModal.module.css";

export const MODAL_BID_ASK_ORDER_TYPE_OPTIONS = [
  { value: "Bid-Ask%", label: "Bid-Ask%" },
  { value: "LIMIT", label: "Limit order" },
];

export const DEFAULT_MODAL_BID_ASK_ORDER_TYPE = "Bid-Ask%";

export const modalBidAskSelectMenuProps = {
  PaperProps: { className: modalStyles["modal-bidask-menu-paper"] },
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
};

const BID_ASK_NUMBER_FIELD_SX = {
  "& .MuiInputBase-input": {
    textAlign: "center",
    paddingLeft: "8px",
    paddingRight: "8px",
  },
  "& .MuiOutlinedInput-input": {
    textAlign: "center",
  },
  "& input[type='number']": {
    textAlign: "center",
  },
};

function ModalBidAskField({
  orderType = DEFAULT_MODAL_BID_ASK_ORDER_TYPE,
  onOrderTypeChange,
  value,
  onChange,
  disabled = false,
}) {
  return (
    <div className={modalStyles["modal-bidask-container"]}>
      <Select
        value={orderType}
        size="small"
        className={modalStyles["modal-bidask-select"]}
        onChange={onOrderTypeChange}
        disabled={disabled}
        MenuProps={modalBidAskSelectMenuProps}
      >
        {MODAL_BID_ASK_ORDER_TYPE_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      <TextField
        size="small"
        type="number"
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={modalStyles["modal-bidask-number"]}
        sx={BID_ASK_NUMBER_FIELD_SX}
      />
    </div>
  );
}

export default ModalBidAskField;
